<template>
    <div>
<section class="page-title">
    <div class="center imagem more-padding">
        <h1 class="the-title"><span>Gerenciador </span>de Parcerias</h1>
    </div>
        </section>
        <v-bottom-nav
            :active.sync="activeBtn"
            :value="showNav"
            color="transparent"
            >

            <v-btn flat color="#009b9b" value="desenv"  
            style="text-decoration:none"
            @click.prevent="alternate = true">
                <span>Cadastrar Parceria</span>
                <v-icon>person_add</v-icon>
            </v-btn>      

            <v-btn flat color="#009b9b" value="emteste" 
            style="text-decoration:none"
            @click.prevent="alternate = false">
                <span>Consultar Link</span>
                <v-icon>link</v-icon>
            </v-btn>        
            </v-bottom-nav>
        <section class="page-content center">
            <v-container grid-list-md>
            <v-flex xs12 sm12 lg12>
            <div v-show="alternate">
            <v-layout row wrap>                                    
            <v-flex xs12 sm12 lg6>   
            <v-text-field
            v-model="ConfigParceria.parceiro"
            label="Parceiro"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg6>      
            <v-text-field
            v-model="ConfigParceria.urlLogo"
            label="URL Logo"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg3>      
            <v-text-field
            v-model="ConfigParceria.plano.nome"
            label="Plano"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg3>      
            <v-text-field
            v-model="ConfigParceria.plano.ans"
            label="Nº ANS"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg3>      
            <v-text-field
            v-model="ConfigParceria.plano.contratacao"
            label="Tipo Contratação"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg3>      
            <v-text-field
            v-model="ConfigParceria.plano.valor"
            label="Valor do Plano"
            box
            ></v-text-field>
            </v-flex> 
            <v-flex xs12 sm12 lg12>
                <v-textarea
                box
                name="input-7-4"
                label="Descrição da Parceria"
                v-model="ConfigParceria.descParceria"
                ></v-textarea>  
            </v-flex>                     
        </v-layout>
        <v-layout style="justify-content: flex-end;">
            <v-card-actions>
            <v-flex>
                <v-btn
                style="border-radius: 6px;"
                large                
                dark
                @click="gerarLink()"
                color="#009b9b"
                >Salvar Parceria</v-btn>
            </v-flex>
            </v-card-actions>
        </v-layout>
        <br>
        <v-layout row wrap justify-center v-if="link != ''">               
            <v-flex xs12 md12 sm12 lg12> 
            <p class="titulo">Link Gerado</p>
            </v-flex>
            <v-flex xs12 md12 sm12 lg12 class="link">
            <a style="font-decoration-none; color:#009b9b" target="_blank" :href="link">{{link}}</a>
            </v-flex>
        </v-layout>
        </div>
        <br>
        </v-flex>
        </v-container>
        </section>

    <Snackbar ref=chamaSnackbar />
    </div>
</template>

<script>
import Snackbar from '../components/snackbar.vue'
import axios from 'axios'
import { baseApiUrl } from '@/global'
import { mapState } from 'vuex'
import CpfValidate from '../components/validators/rules/cpf'
export default {
    components: {Snackbar},
     data(){
        return{
            alternate: true,
            activeBtn: 'desenv',
            showNav: true,
            planos: [],
            idPlano: '',
            vendedor: '',
            nomeVendedor: '',
            cpfVendedor: '',
            link: '',
            ConfigParceria: {
              parceiro: '',
              urlLogo: '',
              descParceria: '',
              plano: {
                  nome: '',
                  ans: '',
                  contratacao: '',
                  valor: ''
              }


            }
        }
    },
    computed: mapState({
        userloggedin: state => state.userloggedin,
    }),
    mounted : function(){
        this.carregaDados()

    },
    methods: {
       async carregaDados(){
           await axios.get(`${baseApiUrl}Plans`).then(res => {        
            if(res.data != null){      
            this.planos = res.data  
            }              	
			})          
        },

        async consultaVendedor(){                 
        if(CpfValidate(this.cpfVendedor)){      
         await axios
          .post(`${baseApiUrl}APIS4s/Vendedores`, {"cpf" : this.cpfVendedor})
          .then(res => {
           if(res.data != ''){
             this.vendedor = res.data[0]
             this.nomeVendedor = this.vendedor.Nome
           } 
           else{
              var vmcpfvend = this
              vmcpfvend.$refs.chamaSnackbar.snack("#F9A825","Vendedor não localizado","ATENÇÃO");
              this.nomeVendedor = '' 
           }           
          })
        }
        else
           this.dialogLoad = false

      },
      gerarLink() {
          if(this.idPlano == '')
          {
          var vm = this
          vm.$refs.chamaSnackbar.snack("#F9A825","Informe o plano para gerar o link!","ATENÇÃO");
          }
          else
          if(this.nomeVendedor == '' || this.cpfVendedor == '')
          this.link = 'https://ecommerce.primavida.com.br/contratopf?plano='+this.idPlano
          else
          this.link = 'https://ecommerce.primavida.com.br/contratopf?plano='+this.idPlano+'&vendedor='+this.cpfVendedor
      }
    }

}
</script>

<style>
    .link{
        font-size: 1.3rem;
        color: #009b9b;
        text-align: center;
    }
    .titulo{
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }
    .imagem{
        background: url('../Content/images/parceria2.png') center right no-repeat;
        background-size: contain;
    }
</style>
